import { render } from "./settlement-year.vue?vue&type=template&id=a0965d34"
import script from "./settlement-year.vue?vue&type=script&lang=js"
export * from "./settlement-year.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__